import React from 'react';
import styles from './StatInvenWeaponViewN.scss';
import classNames from 'classnames/bind';

import {NumericFormat} from 'react-number-format';

import {Link} from 'react-router-dom';

import { calcDamage } from 'util/damageCalc';

const cx = classNames.bind(styles);

const StatInvenWeaponView = ({inputClick, setStat, myStat, currSelWeapon}) => {
  const {con, ski, itemDmg, itemCri, achDmg, rimtDmg, isPara, isDoping, weaponType, monSize, monType, selSkillSeq} = myStat;
  const {
    weaponSkillList,
    inven_cri,
    head_atk_rt,
    inven_dmg,
    totalDmg
  } = calcDamage({myStat, currSelWeapon});
  
  const checkedParaY = isPara === 'Y' ? true : false;
  const checkedParaN = isPara === 'N' ? true : false;
  const checkedDopingY = isDoping === 'Y' ? true : false;
  const checkedDopingN = isDoping === 'N' ? true : false;
  const {currItem} = currSelWeapon;
  const {STYPE1, ITEM_DTL_DV} = currItem;

  const skillListHtml = 
    weaponSkillList.filter(skill => skill.weaponType === ITEM_DTL_DV || skill.seq === '0')
    .map((skill1, cnt) => {
      const {name, increaseTarget, increaseRt, seq} = skill1;
      const incDvNm = increaseTarget === 'cri' ? '치명타' : '모든';
      return (
        <React.Fragment key={`skill-list-${cnt}`}>
          <input type='radio' name="selSkillSeq" id={`skill${cnt}`} onChange={setStat} 
            value={seq} checked={selSkillSeq===seq ? true : false} />
          <label htmlFor={`skill${cnt}`}>
            {seq === '0' ? '없음' : `${name} (${incDvNm}공격력 ${increaseRt}배)`}
          </label>
        </React.Fragment>
      );
    });

  const SkillEmptyHtml = () => {
    return (
      <>
        <input type='radio' name="skill" id="skill0" />
        <label htmlFor="skill0">없음</label>
      </>
    );
  } 
  
  const weaponType1Checked = weaponType === '일반' ? true : false;
  const weaponType2Checked = weaponType === '소이' ? true : false;
  const weaponType3Checked = weaponType === 'Slug' ? true : false;
  const weaponType4Checked = weaponType === '철갑' ? true : false;
  const weaponType5Checked = weaponType === '열화' ? true : false;
  const weaponType6Checked = weaponType === '유탄' ? true : false;
  const weaponType7Checked = weaponType === '대인로켓' ? true : false;
  const weaponType8Checked = weaponType === '대전차탄' ? true : false;
  const weaponType9Checked = weaponType === '대전차로켓' ? true : false;
  const weaponType10Checked = weaponType === '중금속' ? true : false;
  const weaponType11Checked = weaponType === '전속성' ? true : false;

  const monSize1Checked = monSize === '소형' ? true : false;
  const monSize2Checked = monSize === '중형' ? true : false;
  const monSize3Checked = monSize === '대형' ? true : false;

  const monType1Checked = monType === '일반' ? true : false;
  const monType2Checked = monType === '연성' ? true : false;
  const monType3Checked = monType === '강성' ? true : false;
  const monType4Checked = monType === '변이' ? true : false;
  const monType5Checked = monType === '장갑' ? true : false;
  const monType6Checked = monType === '중장갑' ? true : false;

  const {normalDmg, normalDmgFire, criDmg, criDmgFire, headDmg, headDmgFire} = totalDmg;
  
  return (
    <div className={cx('stat-card')}>
      <h2>전투능력</h2>
      <div className={cx('stat-info')}>
        <span style={{color:'#ff5252'}}>
          <NumericFormat 
            value={inven_dmg} displayType={'text'} 
            thousandSeparator={true} 
            prefix={'공격력: '}
          />
        </span>
        <span style={{color:'gold'}}>치명: {inven_cri}({head_atk_rt}배)</span>
        <span style={{color:'#e0e0e0ff'}}>
          <NumericFormat 
            value={normalDmg.min} displayType={'text'} 
            thousandSeparator={true}
            prefix={'일반: '}
          />~ 
          <NumericFormat 
            value={normalDmg.max} displayType={'text'} 
            thousandSeparator={true}
          />
        </span>
        <span style={{color:'#e0e0e0ff'}}>
          <NumericFormat 
            value={normalDmgFire.min} displayType={'text'} 
            thousandSeparator={true}
            prefix={'일반 발화: '}
          />~ 
          <NumericFormat 
            value={normalDmgFire.max} displayType={'text'} 
            thousandSeparator={true}
          />
        </span>
        <span style={{color:'#ffb347'}}>
          <NumericFormat 
            value={criDmg.min} displayType={'text'} 
            thousandSeparator={true}
            prefix={'크리티컬: '}
          />~ 
          <NumericFormat 
            value={criDmg.max} displayType={'text'} 
            thousandSeparator={true}
          />
        </span>
        <span style={{color:'#ffb347'}}>
          <NumericFormat 
            value={headDmg.min} displayType={'text'} 
            thousandSeparator={true} 
            prefix={'헤드샷: '}
          />~ 
          <NumericFormat 
            value={headDmg.max} displayType={'text'} 
            thousandSeparator={true}
          />
        </span>
        <span style={{color:'#ffa07a'}}>
          <NumericFormat 
            value={criDmgFire.min} displayType={'text'} 
            thousandSeparator={true}
            prefix={'크리티컬 발화: '} 
          />~ 
          <NumericFormat 
            value={criDmgFire.max} displayType={'text'} 
            thousandSeparator={true}
          />
        </span>
        <span style={{color:'#ffa07a'}}>
          <NumericFormat 
            value={headDmgFire.min} displayType={'text'} 
            thousandSeparator={true}
            prefix={'헤드샷 발화: '} 
          />~ 
          <NumericFormat 
            value={headDmgFire.max} displayType={'text'} 
            thousandSeparator={true}
          />
        </span>
      </div>

      <div className={cx('battle-action')}>
        <Link to="/simc" className={cx('battle-action__link')}
          state={{totalDmg}}
        >
          사냥 시뮬레이션 시작
        </Link>

        <div className={cx('battle-action__desc')}>
          현재 무기 · 스탯 · 스킬 설정이 그대로 적용됩니다
        </div>
      </div>

      <div className={cx('section-stat')}>
        <div className={cx('section-title-stat')}>기본능력</div>
        <div className={cx('stats-grid')}>
          <div className={cx('stat-input')}>
            <label>체력</label>
            <input type='number' className={cx('stat-insert')}
            name="con" onClick={inputClick} onChange={setStat} value={con}/>
          </div>
          <div className={cx('stat-input')}>
            <label>기술</label>
            <input type='number' className={cx('stat-insert')} 
            name="ski" onClick={inputClick} onChange={setStat} value={ski}/>
          </div>
          <div className={cx('stat-input')}>
            <label>템공합</label>
            <input type='number' className={cx('stat-insert')} 
            name="itemDmg" onClick={inputClick} onChange={setStat} value={itemDmg}/>
          </div>
          <div className={cx('stat-input')}>
            <label>템치합</label>
            <input type='number' className={cx('stat-insert')} 
            name="itemCri" onClick={inputClick} onChange={setStat} value={itemCri}/>
          </div>
          <div className={cx('stat-input')}>
            <label>업적공</label>
            <input type='number' className={cx('stat-insert')} 
            name="achDmg" onClick={inputClick} onChange={setStat} value={achDmg}/>
          </div>
          <div className={cx('stat-input')}>
            <label>해방공</label>
            <input type='number' className={cx('stat-insert')} 
            name="rimtDmg" onClick={inputClick} onChange={setStat} value={rimtDmg}/>
          </div>
        </div>
      </div>

      <div className={cx('section-stat')}>
        <div className={cx('section-title-stat')}>캐릭터 특성</div>
        <div className={cx('radio-group')}>
          <input type='radio' name="isPara" id="isParaN" onChange={setStat} value="N" checked={checkedParaN}/>
          <label htmlFor="isParaN">휴먼</label>
          <input type='radio' name="isPara" id="isParaY" onChange={setStat} value="Y" checked={checkedParaY}/>
          <label htmlFor="isParaY">변이</label>

          <input type='radio' name="isDoping" id="isDopingY" onChange={setStat} value="Y" checked={checkedDopingY}/>
          <label htmlFor="isDopingY" style={{'marginLeft':'10px'}}>공앰</label>
          <input type='radio' name="isDoping" id="isDopingN" onChange={setStat} value="N" checked={checkedDopingN}/>
          <label htmlFor="isDopingN">없음</label>
        </div>
      </div>

      <div className={cx('section-stat')}>
        <div className={cx('section-title-stat')}>무기스킬</div>
        <div className={cx('radio-group')}>
          {skillListHtml.length === 0 ? <SkillEmptyHtml/> : skillListHtml}
        </div>
      </div>

      <div className={cx('section-stat')}>
        <div className={cx('section-title-stat')}>무기속성</div>
        <div className={cx('radio-group')}>
          <input type='radio' name="weaponType" id="weaponType1" onChange={setStat} value="일반" checked={weaponType1Checked}/>
          <label htmlFor="weaponType1">일반</label>
          {STYPE1 === '1' ? <>
          <input type='radio' name="weaponType" id="weaponType2" onChange={setStat} value="소이" checked={weaponType2Checked}/>
          <label htmlFor="weaponType2">소이</label>
          <input type='radio' name="weaponType" id="weaponType3" onChange={setStat} value="Slug" checked={weaponType3Checked}/>
          <label htmlFor="weaponType3">Slug</label>
          <input type='radio' name="weaponType" id="weaponType4" onChange={setStat} value="철갑" checked={weaponType4Checked}/>
          <label htmlFor="weaponType4">철갑</label>
          </>
          : null}
          {STYPE1 === '1' ? <>
          <input type='radio' name="weaponType" id="weaponType5" onChange={setStat} value="열화" checked={weaponType5Checked}/>
          <label htmlFor="weaponType5">열화</label>
          <input type='radio' name="weaponType" id="weaponType6" onChange={setStat} value="유탄" checked={weaponType6Checked}/>
          <label htmlFor="weaponType6">유탄</label>
          <input type='radio' name="weaponType" id="weaponType7" onChange={setStat} value="대인로켓" checked={weaponType7Checked}/>
          <label htmlFor="weaponType7">대인로켓</label>
          <input type='radio' name="weaponType" id="weaponType8" onChange={setStat} value="대전차탄" checked={weaponType8Checked}/>
          <label htmlFor="weaponType8">대전차탄</label>
          <input type='radio' name="weaponType" id="weaponType8" onChange={setStat} value="대전차탄" checked={weaponType8Checked}/>
          <label htmlFor="weaponType8">대전차탄</label>
          <input type='radio' name="weaponType" id="weaponType9" onChange={setStat} value="대전차로켓" checked={weaponType9Checked}/>
          <label htmlFor="weaponType9">대전차로켓</label>
          <input type='radio' name="weaponType" id="weaponType10" onChange={setStat} value="중금속" checked={weaponType10Checked}/>
          <label htmlFor="weaponType10">중금속</label>
          <input type='radio' name="weaponType" id="weaponType11" onChange={setStat} value="전속성" checked={weaponType11Checked}/>
          <label htmlFor="weaponType11">전속성</label>
          </> : null}
        </div>
      </div>

      <div className={cx('section-stat')}>
        <div className={cx('section-title-stat')}>몬스터정보</div>
        <div className={cx('radio-group')}>
          <input type='radio' name="monSize" id="monSize1" onChange={setStat} value="소형" checked={monSize1Checked}/>
          <label htmlFor="monSize1">소형</label>
          <input type='radio' name="monSize" id="monSize2" onChange={setStat} value="중형" checked={monSize2Checked}/>
          <label htmlFor="monSize2">중형</label>
          <input type='radio' name="monSize" id="monSize3" onChange={setStat} value="대형" checked={monSize3Checked}/>
          <label htmlFor="monSize3">대형</label>
        </div>
        <div className={cx('radio-group')}>
          <input type='radio' name="monType" id="monTyle1" onChange={setStat} value="일반" checked={monType1Checked}/>
          <label htmlFor="monTyle1">일반</label>
          <input type='radio' name="monType" id="monTyle2" onChange={setStat} value="연성" checked={monType2Checked}/>
          <label htmlFor="monTyle2">연성</label>
          <input type='radio' name="monType" id="monTyle3" onChange={setStat} value="강성" checked={monType3Checked}/>
          <label htmlFor="monTyle3">강성</label>
          <input type='radio' name="monType" id="monTyle4" onChange={setStat} value="변이" checked={monType4Checked}/>
          <label htmlFor="monTyle4">변이</label>
          <input type='radio' name="monType" id="monTyle5" onChange={setStat} value="장갑" checked={monType5Checked}/>
          <label htmlFor="monTyle5">장갑</label>
          <input type='radio' name="monType" id="monTyle6" onChange={setStat} value="중장갑" checked={monType6Checked}/>
          <label htmlFor="monTyle6">중장갑</label>
        </div>
      </div>
    </div>
  );
}

export default StatInvenWeaponView;

